import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlValueAccessor } from 'src/app/admin/reports/csat-builder/common/base-control-value-accessor.abstract';

@Component({
  selector: 'gcc-survey-negative-radio',
  templateUrl: './survey-negative-radio.component.html',
  styleUrls: ['./survey-negative-radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SurveyNegativeRadioComponent),
      multi: true
    }
  ],
  standalone: false
})
export class SurveyNegativeRadioComponent extends BaseControlValueAccessor<any> implements OnInit {
  @Input() options: { id: string; text: string }[] = [];
  @Output() public onValueChanged = new EventEmitter();

  form = new FormGroup({
    selected: new FormControl('')
  });

  ngOnInit(): void {
    this.form.valueChanges.subscribe(value => {
      this.onValueChanged.emit(value);
    });
  }
}
